// Support-impersonation banner strings (auto-merged by lib/i18n.ts).
export const en = {
  'portal.impersonation.prefix': 'Support view by',
  'portal.impersonation.expires_in': 'expires in',
  'portal.impersonation.exit': 'Exit support view',
}

export const zhTW = {
  'portal.impersonation.prefix': '支援檢視者：',
  'portal.impersonation.expires_in': '到期倒數',
  'portal.impersonation.exit': '結束支援檢視',
}
